/**
 * Step to enter a date of birth for Student Clever Library users
 */
import {t} from "@lingui/core/macro";
import * as React from "react";

import Button from "@khanacademy/wonder-blocks-button";
import {View} from "@khanacademy/wonder-blocks-core";
import {Strut} from "@khanacademy/wonder-blocks-layout";
import {spacing} from "@khanacademy/wonder-blocks-tokens";
import {HeadingMedium} from "@khanacademy/wonder-blocks-typography";

import BirthdayPicker from "~/components/birthday-picker/birthday-picker.tsx";

interface Props {
    onSignUpClick: (arg1: string) => void;
    /**
     * Optional identifier to use for the dialog title.
     *
     * Usefult for announcing the dialog to Screen Readers, as it will be used
     * as the `aria-labelledby` attribute of the dialog.
     */
    titleId?: string;
}

export default function DateOfBirthStep({onSignUpClick, titleId}: Props) {
    const [birthdate, setBirthdate] = React.useState("");

    const updateBirthdate = React.useCallback(
        (newBirthdate?: string | null) => {
            setBirthdate(newBirthdate || "");
        },
        [],
    );

    return (
        <View>
            <Strut size={spacing.medium_16} />
            <HeadingMedium id={titleId}>
                {t`What's your birthday?`}
            </HeadingMedium>
            <Strut size={spacing.large_24} />
            <BirthdayPicker onChange={updateBirthdate} />
            <Strut size={spacing.xLarge_32} />
            <Button
                onClick={() => onSignUpClick(birthdate)}
                disabled={!birthdate}
            >
                {t`Sign up with your school email`}
            </Button>
        </View>
    );
}
